import React, { useState } from "react";
import { Controller } from "react-hook-form";
import styles from "./auto-rule-fields.module.css";
import CustomSelect from "../../../../../common/input/custom-select/custom-select";
import { Select } from "antd";

const AutoRuleFields = ({ control, getValues, record }) => {
  const [capacityWarning, setCapacityWarning] = useState("");
  const currentSections = record?.current_level?.sections?.filter(
    (section) => section?.total_students > 0
  );
  const currentSectionCount = currentSections?.length ?? 0;
  const nextSectionCount = record?.next_level?.sections?.length ?? 0;

  const checkCapacity = () => {
    const { sourceClassroomId, targetClassroomId } = getValues();
    if (!sourceClassroomId || !targetClassroomId) {
      setCapacityWarning("");
      return;
    }

    const from = record?.current_level?.sections?.find(
      (s) => s?.id === sourceClassroomId
    );
    const to = record?.next_level?.sections?.find(
      (s) => s?.id === targetClassroomId
    );

    if (!from || !to) {
      setCapacityWarning("");
      return;
    }

    if (to?.capacity < from?.total_students) {
      setCapacityWarning("Note: Selected section capacity is less than current students.");
    } else {
      setCapacityWarning("");
    }
  };

  return (
    <div className={styles.sectionInputContainer}>
      <Controller
        name="sourceClassroomId"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="sourceClassroomId"
            label="Source Classroom"
            showRequired
            labelColor="#667085"
            placeholder="--Select--"
            showSearch
            size="large"
            value={value}
            onChange={(val) => {
              onChange(val);
              setTimeout(checkCapacity, 0);
            }}
            status={error ? "error" : ""}
          >
            {record?.current_level?.sections?.map((option) => (
              <Select.Option
                key={option?.id}
                value={option?.id}
              >
                {`${option?.name} (Student: ${option?.total_students ?? 0})`}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />

      <Controller
        name="targetClassroomId"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="targetClassroomId"
            label="Target Classroom"
            showRequired
            labelColor="#667085"
            placeholder="--Select--"
            showSearch
            size="large"
            value={value}
            onChange={(val) => {
              onChange(val);
              setTimeout(checkCapacity, 0);
            }}
            status={error ? "error" : ""}
          >
            {record?.next_level?.sections?.map((option) => (
              <Select.Option
                key={option?.id}
                value={option?.id}
              >
                {`${option?.name} (Capacity: ${option?.capacity ?? 0})`}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />

      {nextSectionCount < currentSectionCount && (
        <div className={styles.warningMessage}>
          "Note: Next level has fewer classes than previous. Please create classes accordingly."
        </div>
      )}
      {capacityWarning && (
        <div className={styles.errorMessage}>
          {capacityWarning}
        </div>
      )}
    </div>
  );
};

export default AutoRuleFields;